'use client';

function getAriaDescribedBy({ error, caption }, descriptionId, { "aria-describedby": other = "" }) {
  const hasDescription = Boolean(error || caption);
  if (!hasDescription && !other) return {};
  const spaceIfNeeded = hasDescription && other ? " " : "";
  return {
    "aria-describedby": `${descriptionId}${spaceIfNeeded}${other}`
  };
}
export {
  getAriaDescribedBy
};
